import { AnyAction } from 'redux';
import { Actions as SearchActions } from 'ha/pages/Search/constants';
import { Actions as CitiesActions } from 'ha/pages/Cities/constants';
import { ActionTypes } from '../actions/setLocalisedLocations';
import * as language from './language';
import { Languages } from '../types';

export const initialState = [];

export default (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case SearchActions.LOAD_DONE: {
      const languages = action.payload.langURLListWithCollections || {};

      return Object.keys(languages).map(code => ({
        code,
        localisedLocation: languages[code],
      }));
    }
    case CitiesActions.LOAD_CITIES_SUCCESS: {
      const languages = action.payload.langURLList || {};

      return Object.keys(languages).map(code => ({
        code,
        localisedLocation: languages[code].replace('/s/', '/'),
      }));
    }
    case ActionTypes.SET: {
      return action.payload;
    }
    default:
      return state;
  }
};

export const getLocalisedLocation = (state: Languages, langCode: string) => {
  const lang = state.filter(
    localisedLang => language.getCode(localisedLang) === langCode,
  )[0];

  return lang ? language.getLocalisedLocation(lang) : null;
};
